define('views/presence/Podio.Views.Presence.PresenceBar.Viewers',['require','underscore','lib/backbone/Backbone.PodioView','views/lib/Podio.Views.SlotMachineCount','jst!presence/presence_bar/_viewers','jst!presence/presence_bar/_avatar','jst!presence/presence_bar/_avatar_more'],function(require) {

  var _ = require('underscore');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var SlotMachineCountView = require('views/lib/Podio.Views.SlotMachineCount');

  var jstViewers = require('jst!presence/presence_bar/_viewers');
  var jstAvatar = require('jst!presence/presence_bar/_avatar');
  var jstAvatarMore = require('jst!presence/presence_bar/_avatar_more');

  return PodioView.extend({

    initialize: function(options) {

      this.elmContainer = this.options.elmContainer;
      this.model = this.options.model;

      this._super();
    },

    updateElementReference: function(elm) {
      this.elmContainer = elm;
    },

    render: function() {
      var viewersCollection = this.model.get('viewers');
      var viewersCount = viewersCollection.length;

      var html = this.getTemplate(jstViewers, {
        count: viewersCount,
        compact: this.options.compact
      });

      this.elmContainer.empty().html(html);

      // Avatars etc.
      var shouldTruncate = viewersCount >= 4;

      if (shouldTruncate) {
        viewersCollection = viewersCollection.first(3);
      }

      var avatarHtml = viewersCollection.map(_.bind(function(user, index) {

        return this.getTemplate(jstAvatar, {
          user : user
        });

      }, this)).join('');

      if (shouldTruncate) {
        avatarHtml += this.getTemplate(jstAvatarMore);
      }

      this.elmContainer.find('.avatars').html(avatarHtml);

      // Slot counter
      if (!this.options.compact) {
        var elmViewersSlotCount = this.elmContainer.find('.slot-count');

        // viewersSlotCountView
        if (!this.viewersSlotCountView) {
          this.viewersSlotCountView = new SlotMachineCountView({
            count: viewersCount
          });
        }

        this.viewersSlotCountView.updateElementReference(elmViewersSlotCount);
        this.viewersSlotCountView.render(viewersCount);
      }

    }

  });

});

